export default "<mat-checkbox>{{ settings['label'] }}</mat-checkbox>\r\n"